export default "__VITE_ASSET__D3QN$hqI__"